import { useEffect, useState } from "react";
import { Badge, BlockStack, Card, InlineStack, Link, Text } from "@shopify/polaris";
import supabase from "../../supabase-client";
import { DEDUCTIBLE_LABEL, DEDUCTIBLE_TONE, money } from "../../utility/egresos";

// Egresos charged to this car (batteries, verificaciones, subarrendamiento…),
// line by line from egreso_car_costs. Renders nothing when there are none.
export default function CarEgresosCard({ carId }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!carId) return;
    supabase
      .from("egreso_car_costs")
      .select("*")
      .eq("car_id", carId)
      .order("occurred_at", { ascending: false })
      .limit(50)
      .then(({ data }) => setRows(data || []));
  }, [carId]);

  if (!rows?.length) return null;
  const total = rows.reduce((s, r) => s + Number(r.amount_cents), 0);

  return (
    <Card>
      <BlockStack gap="300">
        <InlineStack align="space-between">
          <Text variant="headingMd">Egresos</Text>
          <Text tone="subdued">{money(total)}</Text>
        </InlineStack>
        {rows.map((r) => (
          <InlineStack key={`${r.entry_id}:${r.amount_cents}`} align="space-between" blockAlign="center" wrap={false}>
            <BlockStack gap="050">
              <Link url={`/egresos/${r.egreso_id}`}>{r.title}</Link>
              <Text tone="subdued" variant="bodySm">
                {new Date(r.occurred_at).toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" })}
                {r.category ? ` · ${r.category}` : ""}
              </Text>
            </BlockStack>
            <InlineStack gap="200" blockAlign="center" wrap={false}>
              {r.deductible_status !== "deducible" && (
                <Badge tone={DEDUCTIBLE_TONE[r.deductible_status]}>{DEDUCTIBLE_LABEL[r.deductible_status]}</Badge>
              )}
              <Text numeric>{money(r.amount_cents)}</Text>
            </InlineStack>
          </InlineStack>
        ))}
      </BlockStack>
    </Card>
  );
}
